import { useEffect } from "react";
import { useStore } from "../../context/StoreContext";
import { waLink } from "../../lib/whatsapp";
import { WhatsAppIcon } from "../../components/public/WhatsAppIcon";

export default function About() {
  const { settings: s } = useStore();
  useEffect(() => {
    document.title = "Sobre | EMAIA PERFUMES";
  }, []);
  return (
    <div className="mx-auto max-w-3xl px-5 pt-16" data-testid="about-page">
      <p className="eyebrow mb-3">Sobre nós</p>
      <h1 className="font-serif text-4xl font-medium text-[#FAF6F0] sm:text-5xl lg:text-6xl">{s?.store_name || "EMAIA PERFUMES"}</h1>
      <div className="gold-line my-10 w-40" />
      {s?.about_text ? (
        <p className="whitespace-pre-line text-lg leading-relaxed text-[#C9C4BA]" data-testid="about-text">{s.about_text}</p>
      ) : (
        <p className="text-[#A1A1AA]" data-testid="about-text-empty">Conheça nossa seleção de perfumes árabes e fale com a gente pelo WhatsApp.</p>
      )}
      {s?.whatsapp && (
        <a href={waLink(s.whatsapp, "Olá! Gostaria de falar com a EMAIA PERFUMES.")} target="_blank" rel="noopener noreferrer" className="btn-whatsapp mt-10" data-testid="about-whatsapp-button">
          <WhatsAppIcon /> Falar pelo WhatsApp
        </a>
      )}
    </div>
  );
}
